var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language"},[_c('custom-select',{attrs:{"options":_vm.langs,"default":_vm.$i18n.locale},on:{"input":_vm.changeLanguage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }